module.exports = __webpack_public_path__ + "img/result_new.ac0f3aa0.svg";